import ApplicationController from "../../application_component_controller"
import URL from "hb/lib/url"
import { useListen } from "hb/insights/use_listen"
import { useOutlets } from "hb/insights/use_outlets"
import { fetchTurbo } from "hb/lib/fetch"

export default class extends ApplicationController {
  static targets = ["configContent", "emptyState", "widgetConfigContainer"]

  static values = {
    paths: Object,
    ts: String,
    timezone: String
  }

  connect() {
    useListen(this)
    useOutlets(this, { components: ["panels"] })
    this.listenWindow("dashboard:editWidget", this.handleEditWidget)
    this.listenWindow("dashboard:closePanels", this.handleClosePanels)
    this.debounceTimer = null
    this.element.addEventListener('change', this.handleConfigChange.bind(this))
    this.element.addEventListener('input', this.handleConfigInput.bind(this))
  }

  async handleEditWidget({widget, querySessionId}) {
    this.currentWidget = widget
    this.showConfigPanel()
    const params = URL.params();

    try {
      await fetchTurbo({
        path: `${this.pathsValue.query}/widget_config`,
        snakeCaseBody: false,
        jsonBody: {
          widget,
          query_session_id: querySessionId,
          timezone: params.get("timezone"),
          ts: params.get("ts") || this.tsValue
        },
      })
    } catch (error) {
      console.error('Failed to load widget config:', error)
      this.widgetConfigContainerTarget.innerHTML = '<div class="alert alert-danger">Failed to load widget configuration</div>'
    }
  }

  normalizedValue(target) {
    if (target.type === 'checkbox') {
      return target.checked
    } else if (target.type === 'number') {
      return Number(target.value)
    } else {
      return target.value
    }
  }

  handleConfigInput(event) {
    if (!event.target.dataset.configField) return

    const field = event.target.dataset.configField
    const value = this.normalizedValue(event.target)

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    this.debounceTimer = setTimeout(() => {
      this.sendConfigUpdate(field, value)
    }, 300)
  }

  handleConfigChange(event) {
    if (!event.target.dataset.configField) return

    const field = event.target.dataset.configField
    const value = this.normalizedValue(event.target)

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }

    this.sendConfigUpdate(field, value)
  }

  sendConfigUpdate(field, value) {
    if (!this.currentWidget) return

    const updateData = {
      widgetId: this.currentWidget.id,
      field: field,
      value: value,
    }

    this.emitWindow("dashboard:updateProductWidgetConfig", updateData)
  }

  showConfigPanel() {
    if (this.configContentTarget.style.display == "block") return

    this.emptyStateTarget.style.display = "none"
    this.configContentTarget.style.display = "block"

    const panels = this.outletComponent("panels")
    panels.showEndPanel()

    if (this.currentWidget && this.currentWidget.type === "insights_vis") {
      panels.endSizeValue = "600px"
      panels.element.style.setProperty('--end-panel-size', '600px')
    } else {
      panels.endSizeValue = "400px"
      panels.element.style.setProperty('--end-panel-size', '400px')
    }
  }

  handleClosePanels() {
    this.widgetConfigContainerTarget.innerHTML = ''
    this.hideConfigPanel()
  }

  hideConfigPanel() {
    this.emptyStateTarget.style.display = "flex"
    this.configContentTarget.style.display = "none"
    const configPanelBadgersense = document.querySelector('.insights--query--badgersense-component[data-from-config-panel]')
    if (configPanelBadgersense) {
      configPanelBadgersense.remove()
    }

    this.outletComponent("panels").hideEndPanel()
  }

  closePanel() {
    if (this.currentWidget) {
      this.emitWindow("dashboard:finishEditingWidget", { widgetId: this.currentWidget.id })
    }

    this.currentWidget = null
    this.widgetConfigContainerTarget.innerHTML = ''
    this.hideConfigPanel()
  }
}
